@import '../../theme/global.scss';

:host {
  display: flex;
  @include set-font;

  .sr-only {
    @include sr-only;
  }
}

.snap-link {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  font-weight: 700;
  text-decoration: none;
  vertical-align: middle;

  > * {
    display: inline-flex;
  }

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    border-radius: 2px;
    outline: none;
  }

  &--xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  &--sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  &--base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  &--default {
    color: $blue-600;

    &:hover,
    &:active{
      color: $blue-800;
    }

    &:focus-visible {
      box-shadow: 0 0 0 1px #FFF, 0 0 0 2px $blue-500;
    }
  }

  &--danger {
    color: $red-600;

    &:hover,
    &:active{
      color: $red-800;
    }

    &:focus-visible {
      box-shadow: 0 0 0 1px #FFF, 0 0 0 2px $red-500;
    }
  }

  &--warning {
    color: $yellow-600;

    &:hover,
    &:active {
      color: $yellow-800;
    }

    &:focus-visible {
      box-shadow: 0 0 0 1px #FFF, 0 0 0 2px $yellow-500;
    }
  }

  &--success {
    color: $green-600;

    &:hover,
    &:active {
      color: $green-800;
    }

    &:focus-visible {
      box-shadow: 0 0 0 1px #FFF, 0 0 0 2px $green-500;
    }
  }

  &.disabled {
    color: $gray-400;
    cursor: initial;
    pointer-events: none;
  }

  &--with-icon {
    text-decoration: none;

    &.snap-link--icon-left {
      .snap-icon {
        margin-right: 4px;
      }
    }

    &.snap-link--icon-right {
      .snap-icon {
        margin-left: 4px;
      }
    }
  }
}
